import type { SpinWheelRegionEntity } from './SpinWheelRegionEntity'

export class UpdateSpinWheelRegionEntity {
  spinWheelRegions?: Array<SpinWheelRegionEntity> | null
}
